var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42782 22.5176V12.6964",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5717 22.5174V13.8578",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.32584 19.5133L1.4378 20.8913C1.5463 21.7018 2.20767 22.3236 3.02398 22.3729C5.10675 22.4989 9.08163 22.7142 11.931 22.7142C14.7189 22.7142 18.584 22.5082 20.7003 22.3813C21.5759 22.3289 22.2659 21.6207 22.3028 20.7444L22.7142 10.9489V8.26691",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6024 5.15455C22.7514 3.65503 22.7515 2.83142 22.6024 1.39737C21.1684 1.24836 20.3449 1.24844 18.8454 1.39737",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28566 15.3168C3.35753 12.2752 5.78105 9.8517 8.82271 7.77992L12.5212 11.4785C16.0901 8.87361 19.7317 5.09382 22.3366 1.52496",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAdmin);
export default __webpack_public_path__ + "static/media/sidebar_admin.51da6525acb673502423cdfdeaaf3658.svg";
export { ForwardRef as ReactComponent };